// extracted by mini-css-extract-plugin
export default {"container":"sub-main_page_container__8s6p4","sidebar":"sub-main_page_sidebar__jxfbO","outletContainer":"sub-main_page_outletContainer__wWW2u"};